import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppCommonPipesModule } from '../../app-common-pipes/app-common-pipes.module';
import { EntryAccountStatementComponent } from './entry-account-statement.component';


@NgModule({
  declarations: [ EntryAccountStatementComponent ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    AppCommonPipesModule
  ],
  exports: [ EntryAccountStatementComponent ]
})
export class EntryAccountStatementModule { }
